import React, { useMemo } from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";
import { formatPen } from "../../../../utils/finance/format";

function toChartData(breakdowns) {
  const arr = breakdowns?.sales_by_service_type || [];
  return arr.map((x) => ({
    name: x.service_type,
    total: Number(x.total || 0),
    count: Number(x.count || 0),
  }));
}

export function FinanceServiceMixChart({ breakdowns }) {
  const data = useMemo(() => toChartData(breakdowns), [breakdowns]);

  return (
    <Card sx={{ borderRadius: 6 }}>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Ventas por servicio
        </Typography>

        <Box sx={{ height: 320 }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" tick={{ fontSize: 12 }} />
              <YAxis tick={{ fontSize: 12 }} />
              <Tooltip
                formatter={(value, name, props) => {
                  if (name === "total") return [formatPen(value), "Total"];
                  return [value, name];
                }}
                labelFormatter={(label) => `Servicio: ${label}`}
              />
              <Bar dataKey="total" />
            </BarChart>
          </ResponsiveContainer>
        </Box>
      </CardContent>
    </Card>
  );
}
